<template>
	<div class="lable contains">
		<div class="content-tit">
			<div class>
				<h2>客户标签</h2>
				<p class="points">通过标签，客服可对顾客进行分类，以便后续整理和分析</p>
			</div>

			<el-button class="add" type="primary" @click="AddXianshi">添加新标签</el-button>
			<el-dialog :title="UpdateTitle" :visible.sync="dialogLable">
				<div class="section">
					<div class="lablename">标签名称*</div>
					<div class="flex-right">
						<el-input placeholder="请输入内容" v-model="ConsultantInfo_Label.Label_Name"></el-input>
						<div class="points">标签名称是标签的主要标识内容，会在服务过程中进行显示</div>
					</div>
				</div>
				<div class="section">
					<div class="lablename">标签颜色</div>
					<div class="colors">
						<span
							:class="item.class"
							@click="choose(colors,index)"
							:style=" 'background-color:'+item.color"
							v-for="(item,index) in colors"
						>
							<i :style=" 'background-color:'+item.color"></i>
						</span>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogLable = false">取 消</el-button>
					<el-button type="primary" @click="Add()" v-if="UpdateBooleam!=true">保存</el-button>
					<el-button type="primary" @click="UpdateLabel" v-if="UpdateBooleam!=false">修改</el-button>
				</span>
			</el-dialog>
		</div>
		<div class="content-main">
			<div class="flex-box">
				<div class="table_box">
					<el-table :data="tableData" style="width: 100%;" border>
						<el-table-column prop="name" label="标签名称" width="120">
							<template slot-scope="scope">
								<div class="lables">
									<span
										v-bind:style="{background:item.class}"
										v-for="(item,index) in  scope.row.name "
									>{{item.name}}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="create_time" label="添加标签时间" sortable>
							<!-- <template slot-scope="scope">{{formatTime(scope.row.create_time)}}</template> -->
						</el-table-column>
						<el-table-column prop="count" label="标签使用次数" sortable></el-table-column>

						<el-table-column fixed="right" label="操作" width="200">
							<template slot-scope="scope">
								<i class="el-icon-edit" @click="UpdateShow(scope.row.Id)" style="cursor: pointer;"></i>
								<i class="el-icon-delete" style="cursor: pointer;" @click="Delete(scope.row.Id)"></i>
								<!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
								<el-button type="text" size="small">编辑</el-button>-->
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination">
					<el-pagination
						@current-change="List"
						:page-size="10"
						background
						layout="total, prev, pager, next"
						:total="SumUser"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { FormatTimes } from '@/utils/FormatTime'
export default {
	name: 'lable',
	props: [],
	data() {
		return {
			UpdateTitle: '添加新标签',
			UpdateBooleam: false,
			ConsultantInfo_Label: {
				Label_Name: '',
				label_UseNumber: 0,
				Label_Color: '#50A2FC',
				Create_time: '2019-1-1',
				Update_time: '2019-1-1'
			},
			tableData: [
				{
					count: 1,
					name: [
						{
							name: '王小虎',
							class: 'red'
						}
					],
					create_time: '10-10 12:12',
					operate: '未处理'
				},
				{
					count: 2,
					name: [
						{
							name: '王小虎',
							class: 'blue'
						}
					],
					operate: '未处理',
					create_time: '10-10 12:12'
				}
			],
			dialogLable: false,
			colors: [
				{
					color: '#50A2FC'
				},
				{
					color: '#22C7DA'
				},
				{
					color: '#19AE9D'
				},
				{
					color: '#67C054'
				},
				{
					color: '#CDDC49'
				},
				{
					color: '#FDA943'
				},
				{
					color: '#BE8860'
				},
				{
					color: '#FD6E4A'
				},
				{
					color: '#F282AA'
				},
				{
					color: '#838CF2'
				},
				{
					color: '#8F8F8F'
				}
			],
			SumUser: 0
		}
	},
	watch: {},
	mounted: function() {
		for (let i = 0; i < this.colors.length; i++) {
			this.colors[i].class = ''
		}
		this.colors[0].class = 'on'
	},
	created: function() {
		this.Total()
		this.List()
	},
	methods: {
		choose(colors, index) {
			for (let i = 0; i < colors.length; i++) {
				colors[i].class = ''
			}
			colors[index].class = 'on'
			this.colors = JSON.parse(JSON.stringify(colors))
			this.ConsultantInfo_Label.Label_Color = colors[index].color
		},
		formatTime(time) {
			return FormatTimes(time, 'yyyy-MM-dd hh:mm:ss')
		},
		Total() {
			//初始化  客户总人数
			let $this = this
			this.axios
				.get('ConsultantInfo_Label/Sum', {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
					$this.SumUser = data.data
				})
		},
		//返回客户列表
		List(PageSize, PageNum) {
			PageNum = 10
			let $this = this
			this.axios
				.get(
					'ConsultantInfo_Label/List',
					{
						params: {
							pages: PageSize,
							pageNum: PageNum
						}
					},
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data) {
					$this.tableData = []
					data.data.forEach(element => {
						$this.tableData.push({
							count: element.label_UseNumber,
							Id: element.label_id,
							create_time: element.create_time.replace('T', ' '),
							operate: '未处理',
							name: [
								{
									name: element.label_Name,
									class: element.label_Color
								}
							]
						})
					})
				})
		},
		Add() {
			let $this = this
			if (this.ConsultantInfo_Label.Label_Name == '') {
				$this.$message({ type: 'error', message: '请输入标签名称！' })
				return
			}
			this.axios
				.post('ConsultantInfo_Label/Add', this.ConsultantInfo_Label, {
					headers: { 'Content-Type': 'application/json' }
				})
				.then(function(data) {
					if (data.data.message == '成功') {
						$this.$message({
							message: '添加成功',
							type: 'success'
						})
						$this.dialogLable = false
						$this.Total()
						$this.List()
						$this.ConsultantInfo_Label = {
							Label_Name: '',
							label_UseNumber: 0,
							Label_Color: '#50A2FC',
							Create_time: '2019-1-1',
							Update_time: '2019-1-1'
						}
					} else {
						$this.$message({
							message: data.data.message,
							type: 'error'
						})
					}
				})
		},
		//修改时返回Model
		UpdateShow(Id) {
			let $this = this
			$this.dialogLable = true
			$this.UpdateBooleam = true
			$this.UpdateTitle = '修改新标签'

			this.axios
				.get(
					'ConsultantInfo_Label/UpdateModel',
					{
						params: {
							Id: Id
						}
					},
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data) {
					$this.ConsultantInfo_Label.Label_Name = data.data.label_Name
					$this.ConsultantInfo_Label.Label_Color =
						data.data.label_Color
					$this.ConsultantInfo_Label.Label_id = data.data.label_id

					var index = 0
					for (let i = 0; i < $this.colors.length; i++) {
						$this.colors[i].class = ''
						if ($this.colors[i].color == data.data.label_Color) {
							index = i
						}
					}
					$this.colors[index].class = 'on'
					$this.colors = JSON.parse(JSON.stringify($this.colors))
					$this.ConsultantInfo_Label.Label_Color =
						$this.colors[index].color
				})
		},
		//删除
		Delete(Id) {
			let $this = this
			this.$confirm('是否删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.axios
						.get(
							'ConsultantInfoLabel_Relation/Count?Label_id=' + Id,
							{
								headers: {
									'Content-Type': 'application/json'
								}
							}
						)
						.then(function(data) {
							if (data.data > 0) {
								$this.$message.error('客户上有标签无法删除');
							} else {
								$this.axios
									.post(
										'ConsultantInfo_Label/Delete?Label_id=' +
											Id,
										{
											headers: {
												'Content-Type':
													'application/json'
											}
										}
									)
									.then(function(data1) {
										if (data1.data.message == '成功') {
											$this.$message({
												type: 'success',
												message: '删除成功!'
											})
											$this.Total()
											$this.List()
										} else {
											$this.$message.error(data1.data.message)
										}
									})
							}
						})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		},
		AddXianshi() {
			let $this = this
			$this.dialogLable = true
			$this.UpdateBooleam = false
			$this.UpdateTitle = '添加新标签'
		},
		UpdateLabel() {
			let $this = this
			this.axios
				.post(
					'ConsultantInfo_Label/Update',
					$this.ConsultantInfo_Label,
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data) {
					if (data.data.message == '成功') {
						$this.$message({
							type: 'success',
							message: data.data.message
						})
						for (let i = 0; i < $this.colors.length; i++) {
							$this.colors[i].class = ''
						}
						$this.colors[0].class = 'on'
						$this.Total()
						$this.List()
						$this.dialogLable = false
					} else {
						$this.$message.error(data.data.message)
					}
				})
		}
	}
}

// this.axios
// 		.post('ConsultantInfo_Label/Add', this.ConsultantInfo_Label, {
// 			headers: { 'Content-Type': 'application/json' }
// 		})
// 		.then(function(data) {
// 			if (data.data.message == '成功') {
// 				alert(data.data.message)
// 				$this.dialogLable = false
// 				$this.Total()
// 				$this.List()
// 			} else {
// 				alert(data.data.message)
// 			}
// 		})
</script>

<style scoped>
.lable {
	padding-right: 15px;
}
.content-tit {
	line-height: 20px;
	display: flex;
	display: -webkit-flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 5px;
	border-bottom: 1px solid #ddd;
}
.content-tit h2 {
	font-size: 20px;
	line-height: 30px;
	font-weight: bold;
}
.points {
	color: #999;
}
.add {
	float: right;
}
.flex-box {
	width: 100%;
}
.el-icon-edit {
	cursor: pointer;
	padding: 0 3px;
}
.el-icon-delete {
	cursor: pointer;
	padding: 0 3px;
}
.lables span {
	display: inline-block;
	padding: 0 3px;
	height: 20px;
	line-height: 20px;
	font-size: 12px;
	color: #fff;
	margin: 0 3px 0 0;
	border-radius: 3px;
}
.blue {
	background-color: #ccdb38;
}
.red {
	background-color: #6ed0c7;
}

.section {
	display: flex;
	display: -webkit-flex;
	justify-content: center;
	align-items: flex-start;
	margin-top: 30px;
}
.lablename {
	line-height: 32px;
	margin-right: 20px;
	width: 150px;
	text-align: right;
}
.colors span {
	display: inline-block;
	width: 25px;
	height: 25px;
	margin: 3px 5px;
	cursor: pointer;
	border: 2px solid transparent;
	text-align: center;
	box-sizing: border-box;
	line-height: 25px;
}
.colors span.on {
	background-color: #fff !important;
	border-color: red;
}
.colors span i {
	display: inline-block;
	width: 15px;
	height: 15px;
}
/*  .colors span:hover{
    background-color:#fff!important;
    border-color:red;
  }*/
.flex-right {
	width: 60%;
}
.colors {
	width: 60%;
	line-height: 32px;
}
.table_box {
	margin-top: 30px;
}
.pagination {
	text-align: right;
}
.el-pagination {
	text-align: right;
	margin-top: 50px;
	display: inline-block;
}
</style>
<style>
.lable .el-input__inner {
	background-color: transparent;
	margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/client/lable.vue